'use client';

import Image from 'next/image';
import Link from 'next/link';
import { Box, Button, Unstable_Grid2 as Grid, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import CheckIcon from '@/public/icons/home/check.svg';
import Section from '@/components/Section';
const texts = {
  title: 'همین حالا ثبت‌نام کن,',
  desc: 'با زیما، سرمایه‌های خرد شما به پروژه‌هایی با تأثیر اجتماعی بزرگ تبدیل می‌شود.',
  btn1Title: 'دیدن فرصت‌های سرمایه‌گذاری',
  goldGift: '۵ سوت طلا',
  investmentMessage: 'با زیما، هوشمندانه سرمایه‌گذاری کن و در پروژه‌های بزرگ شریک شو. همین حالا ثبت‌نام کن و هدیه بگیر!',
  registrationMessage: 'همین حالا ثبت‌نام کن و هدیه بگیر!',
  supervisionMessage: 'فعالیت تحت نظارت فرابورس ایران',
  participationMessage: 'بدون نیاز به سرمایه زیاد، در کسب‌وکارهای واقعی مشارکت کن'
};
const IntroHeader = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  return <Box mt={{
    xs: 2
  }} data-sentry-element="Box" data-sentry-component="IntroHeader" data-sentry-source-file="IntroHeader.tsx">
      <Grid container direction={{
      xs: 'column-reverse',
      md: 'row'
    }} data-sentry-element="Grid" data-sentry-source-file="IntroHeader.tsx">
        <Grid xs={12} md={5} data-sentry-element="Grid" data-sentry-source-file="IntroHeader.tsx">
          <Section sx={{
          gap: {
            xs: 'var(--spacing_xl)',
            md: 'var(--spacing_m)'
          },
          py: {
            xs: 'var(--spacing_l)',
            md: 'var(--spacing_xxxl)'
          }
        }} data-sentry-element="Section" data-sentry-source-file="IntroHeader.tsx">
            <Stack sx={{
            alignItems: {
              xs: 'center',
              md: 'flex-start'
            },
            gap: 'var(--spacing_xs)'
          }} data-sentry-element="Stack" data-sentry-source-file="IntroHeader.tsx">
              <Typography fontSize={{
              xs: 20,
              md: 32
            }} fontWeight={700} component='h3' data-sentry-element="Typography" data-sentry-source-file="IntroHeader.tsx">
                {texts.title}
              </Typography>
              <Typography fontSize={{
              xs: 32,
              md: 40
            }} component='h1' data-sentry-element="Typography" data-sentry-source-file="IntroHeader.tsx">
                <strong className='highlight-primary'>{texts.goldGift}</strong>
                هدیه بگیر.
              </Typography>

              <Typography fontSize={{
              xs: 16,
              md: 24
            }} fontWeight={500} component='h2' data-sentry-element="Typography" data-sentry-source-file="IntroHeader.tsx">
                {texts.investmentMessage}
              </Typography>
            </Stack>

            <Stack sx={{
            flexDirection: {
              xs: 'column',
              md: 'column-reverse'
            },
            alignItems: {
              xs: 'center',
              md: 'flex-start'
            },
            gap: {
              xs: 'var(--spacing_xl)',
              md: 'var(--spacing_xxxl)'
            }
          }} data-sentry-element="Stack" data-sentry-source-file="IntroHeader.tsx">
              <Link href='/login' data-sentry-element="Link" data-sentry-source-file="IntroHeader.tsx">
                <Button variant='contained' size='large' color='tertiary' sx={{
                maxWidth: 228
              }} data-sentry-element="Button" data-sentry-source-file="IntroHeader.tsx">
                  ثبت‌نام و دریافت طلا
                </Button>
              </Link>
            </Stack>
          </Section>
        </Grid>

        <Grid xs={12} md={7} position='relative' data-sentry-element="Grid" data-sentry-source-file="IntroHeader.tsx">
          {!isSmallScreen ? <Image src='/images/home/zeema_header.webp' alt='همراهی برای ساختن آینده‌ای روشن' fill style={{
          objectFit: 'contain'
        }} /> : <Image src='/images/home/zeema_header.webp' alt='همراهی برای ساختن آینده‌ای روشن' width={800} height={400} style={{
          width: '100%',
          height: 'auto',
          minHeight: isSmallScreen ? 160 : '100%'
        }} />}
        </Grid>
      </Grid>
      <Stack direction={{
      xs: 'column',
      md: 'row'
    }} sx={{
      width: '100%'
    }} justifyContent='flex-start' gap={{
      xs: 2,
      md: 10
    }} alignItems='flex-start' data-sentry-element="Stack" data-sentry-source-file="IntroHeader.tsx">
        <Stack direction='row' alignItems='flex-start' data-sentry-element="Stack" data-sentry-source-file="IntroHeader.tsx">
          <CheckIcon width={24} data-sentry-element="CheckIcon" data-sentry-source-file="IntroHeader.tsx" />
          <Typography component={'span'} mt={'-5px'} fontSize={14} data-sentry-element="Typography" data-sentry-source-file="IntroHeader.tsx">
            {texts.supervisionMessage}
          </Typography>
        </Stack>
        <Stack direction='row' alignItems='flex-start' data-sentry-element="Stack" data-sentry-source-file="IntroHeader.tsx">
          <CheckIcon width={24} data-sentry-element="CheckIcon" data-sentry-source-file="IntroHeader.tsx" />
          <Typography component={'span'} mt={'-5px'} fontSize={14} data-sentry-element="Typography" data-sentry-source-file="IntroHeader.tsx">
            {texts.participationMessage}
          </Typography>
        </Stack>
      </Stack>
    </Box>;
};
export default IntroHeader;